import React from 'react';
import { Link } from 'react-router-dom';
export default ({ category, site }) => {
    return <>
        <Link to={`/siteApp/${category}/${site}/kaizen/raiseci`}>
            <div className="app">
                <span className="icon kaddIdea" ></span>
                <span className="label" >Raise Kaizen</span>
            </div>
        </Link >
        <Link to={`/siteApp/${category}/${site}/kaizen/cilist/mykaizens`}>
            <div className="app">
                <span className="icon kaizenIdea" ></span>
                <span className="label" style={{ paddingTop: "5px" }}>My Kaizens</span>
            </div>
        </Link >
        <Link to={`/siteApp/${category}/${site}/kaizen/cilist/myapprovals`}>
            <div className="app">
                <span className="icon kmyapproval" ></span>
                <span className="label" >My Approvals</span>
            </div>
        </Link >
        <Link to={`/siteApp/${category}/${site}/kaizen/cilist/all`}>
            <div className="app">
                <span className="icon kaizenIdea" ></span>
                <span className="label" style={{ paddingTop: "5px" }}>All Kaizens</span>
            </div>
        </Link >
        <Link to={`/siteApp/${category}/${site}/kaizen/nomination`}><div className="app">
            <span className="icon knomini" ></span>
            <span className="label" >Nomination</span>
        </div>
        </Link >
        <Link to={`/recognition/${category}/${site}`}><div className="app">
            <span className="icon krecog" ></span>
            <span className="label" >Recognition</span>
        </div>
        </Link >
        <Link to="#"><div className="app">
            <span className="icon kreport" ></span>
            <span className="label" >Reports</span>
        </div>
        </Link >
        <Link to={`/siteApp/${category}/${site}/kaizenAdmin`}><div className="app">
            <span className="icon kadmin" ></span>
            <span className="label" >Admin</span>
        </div>
        </Link >
        <Link to={`/siteApp/${category}/${site}/kaizen/sitefocalinfo`}><div className="app">
            <span className="icon kusers" ></span>
            <span className="label" >Kaizen focal info</span>
        </div>
        </Link ></>
}
